

















































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { ManageThemesResponse, UserPermission } from "@/shared/types";
import { Location } from "vue-router";
import { Validator } from "vee-validate";
import * as RouteNames from "@/admin/route-names";
import Pagination from "@/shared/components/ui/Pagination.vue";
import PageSizeSelectList from "@/shared/components/ui/PageSizeSelectList.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useThemeStore } from "@/shared/store/theme";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";

@Component({
  components: {
    Pagination,
    PageSizeSelectList
  }
})
export default class ManageThemes extends Vue {
  $validator: Validator;
  themes: ManageThemesResponse[] = [];

  themeStore = useThemeStore();
  notifierStore = useNotifierStore();
  rolePermissionsStore = useRolePermissionsStore();

  @Prop() page: number;

  @Prop() routeToThemeList: (page: number) => Location;
  RouteNames = RouteNames;

  isSubmitting = false;
  searchTerm = "";
  searchResultCount = 0;

  mounted (): void {
    this.fetchThemeList(false);
  }

  get submitDisabled (): boolean {
    return this.themeStore.themesFetchLoading || this.isSubmitting;
  }

  @Watch("page")
  onRouteValuePageNumberChanged (): void {
    this.fetchThemeList(false);
  }

  switchPage (toPage): void {
    this.$router.push(this.routeToThemeList(toPage));
  }

  fetchThemeList (clearState: boolean): void {
    if (!clearState) {
      this.themeStore.setPageNumber(this.page);
    }
    this.themeStore.searchThemes(clearState,
        this.themeStore.pageNumber,
        this.searchTerm).then(() => {
          this.themes = this.themeStore.getThemesByPageNumber(this.themeStore.pageNumber);
        })
        .catch(this.handleError);
  }

  onSearch (): void {
    if (!this.isSubmitting) {
      this.isSubmitting = true;
      this.themeStore.setPageNumber(1);
      this.$router.push(this.routeToThemeList(1));
      this.fetchThemeList(true);
      this.isSubmitting = false;
    }
  }

  clearSearch (): void {
    if (!this.isSubmitting) {
      this.isSubmitting = true;
      this.searchTerm = "";
      this.themeStore.setPageNumber(1);
      this.$router.push(this.routeToThemeList(1));
      this.fetchThemeList(true);
      this.isSubmitting = false;
    }
  }

  switchPageSize (): void {
    // on switching page size, reset to page 1
    this.themeStore.setPageNumber(1);
    this.$router.push(this.routeToThemeList(1));
    this.fetchThemeList(true);
  }

  showError (message: string): void {
    this.notifierStore.setDanger(message);
  }

  handleError (err: any): void {
    this.showError(
        (err && err.errorMessage) ||
        "Error processing your request. Please try again later"
    );
  }

  themeStatus (isActive: boolean) {
    if (isActive) {
      return "Active";
    } else {
      return "Inactive";
    }
  }

  routeToTheme (Id) {
    return { name: RouteNames.ManageTheme, params: { themeId: Id } };
  }

  get hasEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityManageThemeEdit);
  }
}
